import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "../DashboardLayout";
import InsightsTab from "../../../../components/InsightsTab";
import { serverUrl } from "../../../../helpers/utility";
import { ArrowRight, ChevronRight, ChevronLeft, Download } from "lucide-react";
import { Nav } from 'react-bootstrap';
import dayjs from "dayjs";

function Insights({ user }) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [insightsData, setInsightsData] = useState(null);
  const [month, setMonth] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`);

  const handleDownloadPDF = async () => {
    try {
      setIsDownloading(true);
      const response = await axios.get(`${serverUrl}/insights/pdf`, {
        responseType: 'blob',
        withCredentials: true
      });

      // Create a blob URL and trigger download
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'insights-report.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  async function fetchInsightsData() {
    try {
      const response = await axios.get(`${serverUrl}/insight/${user.localAuthorityId}/${month}`);
      if(response.data.insight) {
        setInsightsData(response.data.insight);
        return response.data.insight;
      } else {
        setInsightsData(null);
        return null;
      }
    } catch (error) {
      console.error('Error getting insights data:', error);
      // alert('Failed to get insights data. Please try again.');
    }
  }

  useEffect(() => {
    fetchInsightsData();
  }, [month]);

  return (
    <DashboardLayout user={user}>
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h1 className="h3 mb-0">Insights</h1>
            <p className="text-muted medium mt-1 mb-0">{new Date(month).toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })}</p>
          </div>
          <div className="d-flex flex-col justify-content-center align-items-center gap-2">
            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={handleDownloadPDF}
              disabled={isDownloading || !insightsData}
            >
              <Download size={18} />
              {isDownloading ? "Downloading..." : "Download PDF"}
            </button>
            <Nav className="d-flex align-items-center gap-2">
              <Nav.Item>
                <Nav.Link
                  className="p-1 text-center"
                  disabled={dayjs(month).add(1, 'month').isAfter(dayjs())}
                  onClick={() => {
                    setMonth(dayjs(month).add(1, 'month').format('YYYY-MM'));
                  }}
                >
                  <ChevronLeft size={18} /> Next month
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  className="p-1 text-center"
                  onClick={() => {
                    setMonth(dayjs(month).subtract(1, 'month').format('YYYY-MM'));
                  }}
                >
                  Prev month
                  <ChevronRight size={18} />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </div>
        {insightsData && <InsightsTab insightsData={insightsData} />}
        {!insightsData && <div className="d-flex justify-content-center align-items-center">
          <div className="text-center">
            <p className="text-muted medium">No insight data available for {new Date(month).toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })}.</p>
          </div>
        </div>}
      </div>
    </DashboardLayout>
  );
}

export default Insights;
